const colorMappings = {
    white: "#FFFFFF",
    transparent: "#FFFFFF",
  black: "#000000",
  red: "#FF0000",
  blue: "#0000FF",
  green: "#008000",
  gray: "#808080",
  silver: "#C0C0C0",
  orange: "#FFA500",
  yellow: "#FFFF00",
  purple: "#800080",
  fuchsia: "#FF00FF",
  lime: "#00FF00",
  olive: "#808000",
  navy: "#000080",
  teal: "#008080",
  aqua: "#00FFFF",
  maroon: "#800000",
  darkred: "#8B0000",
  brown: "#A52A2A",
  firebrick: "#B22222",
  crimson: "#DC143C",
  tomato: "#FF6347",
  coral: "#FF7F50",
  indianred: "#CD5C5C",
  lightcoral: "#F08080",
  darksalmon: "#E9967A",
  salmon: "#FA8072",
  lightsalmon: "#FFA07A",
  orangered: "#FF4500",
  darkorange: "#FF8C00",
  gold: "#FFD700",
  darkgoldenrod: "#B8860B",
  goldenrod: "#DAA520",
  palegoldenrod: "#EEE8AA",
  darkkhaki: "#BDB76B",
  khaki: "#F0E68C",
  yellowgreen: "#9ACD32",
  darkolivegreen: "#556B2F",
  olivedrab: "#6B8E23",
  lawngreen: "#7CFC00",
  chartreuse: "#7FFF00",
  greenyellow: "#ADFF2F",
  darkgreen: "#006400",
  forestgreen: "#228B22",
  limegreen: "#32CD32",
  darkseagreen: "#8FBC8F",
  mediumseagreen: "#3CB371",
  seagreen: "#2E8B57",
  palegreen: "#98FB98",
  springgreen: "#00FF7F",
  mediumspringgreen: "#00FA9A",
  lightgreen: "#90EE90",
  darkcyan: "#008B8B",
  lightseagreen: "#20B2AA",
  cadetblue: "#5F9EA0",
  darkturquoise: "#00CED1",
  mediumturquoise: "#48D1CC",
  turquoise: "#40E0D0",
  cyan: "#00FFFF",
  lightcyan: "#E0FFFF",
  darkblue: "#00008B",
  mediumblue: "#0000CD",
  royalblue: "#4169E1",
  steelblue: "#4682B4",
  dodgerblue: "#1E90FF",
  deepskyblue: "#00BFFF",
  skyblue: "#87CEEB",
  lightskyblue: "#87CEFA",
  lightsteelblue: "#B0C4DE",
  lightblue: "#ADD8E6",
  powderblue: "#B0E0E6",
  lightpurple: "#9370DB",
  mediumorchid: "#BA55D3",
  orchid: "#DA70D6",
  violet: "#EE82EE",
  plum: "#DDA0DD",
  thistle: "#D8BFD8",
  lavender: "#E6E6FA",
  mistyrose: "#FFE4E1",
  antiquewhite: "#FAEBD7",
  beige: "#F5F5DC",
  bisque: "#FFE4C4",
  blanchedalmond: "#FFEBCD",
  wheat: "#F5DEB3",
  cornsilk: "#FFF8DC",
  lemonchiffon: "#FFFACD",
  lightgoldenrodyellow: "#FAFAD2",
  lightyellow: "#FFFFE0",
  saddlebrown: "#8B4513",
  sienna: "#A0522D",
  chocolate: "#D2691E",
  peru: "#CD853F",
  sandybrown: "#F4A460",
  burlywood: "#DEB887",
  tan: "#D2B48C",
  rosybrown: "#BC8F8F",
  moccasin: "#FFE4B5",
  navajowhite: "#FFDEAD",
  peachpuff: "#FFDAB9",
  lavenderblush: "#FFF0F5",
  linen: "#FAF0E6",
  };
  
  export default colorMappings;